module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-wasou-accessories-ac92a3010d53d24c4fffeca365481a9d.jpg";